function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 20.5L21.75 22.75C22.2139 23.2143 22.4744 23.8437 22.4744 24.5C22.4744 25.1563 22.2139 25.7857 21.75 26.25V26.25",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 13V1H11.1C11.4009 1.00019 11.7015 1.01956 12 1.058",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.75001 15.25L3.25009 15.7499C2.28354 16.7165 2.28354 18.2835 3.25009 19.2501C4.21664 20.2166 5.78372 20.2166 6.75027 19.2501L7.25019 18.7502C8.21674 17.7836 8.21674 16.2165 7.25019 15.25C6.28365 14.2834 4.71656 14.2834 3.75001 15.25Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.38738 18.6129L6.61239 19.3879C5.64585 20.3544 5.64585 21.9215 6.61239 22.888C7.57894 23.8546 9.14602 23.8546 10.1126 22.888L10.8876 22.113C11.8541 21.1465 11.8541 19.5794 10.8876 18.6129C9.92101 17.6463 8.35393 17.6463 7.38738 18.6129Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6143 22.3852L10.1143 22.8852C9.1478 23.8517 9.1478 25.4188 10.1143 26.3853C11.0809 27.3519 12.648 27.3519 13.6145 26.3853L14.1145 25.8854C15.081 24.9189 15.081 23.3518 14.1145 22.3852C13.1479 21.4187 11.5808 21.4187 10.6143 22.3852Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1533 25.847L13.6336 26.3667C12.8053 27.195 12.8053 28.5379 13.6336 29.3662L13.6343 29.3669C14.4626 30.1952 15.8055 30.1952 16.6338 29.3669L17.1535 28.8472C17.9818 28.0189 17.9818 26.676 17.1535 25.8477L17.1528 25.847C16.3245 25.0187 14.9816 25.0187 14.1533 25.847Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0004 17L26.0254 20.025C26.2553 20.2548 26.4377 20.5276 26.5621 20.8278C26.6866 21.1281 26.7506 21.45 26.7506 21.775C26.7506 22.1 26.6866 22.4219 26.5621 22.7222C26.4377 23.0224 26.2553 23.2952 26.0254 23.525C25.7956 23.7549 25.5228 23.9373 25.2226 24.0617C24.9223 24.1862 24.6004 24.2502 24.2754 24.2502C23.9504 24.2502 23.6285 24.1862 23.3282 24.0617C23.028 23.9373 22.7551 23.7549 22.5254 23.525",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.75 19.75C26.2143 20.2139 26.8437 20.4744 27.5 20.4744C28.1563 20.4744 28.7857 20.2139 29.25 19.75C29.7139 19.2857 29.9744 18.6563 29.9744 18C29.9744 17.3437 29.7139 16.7143 29.25 16.25L20 7",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20 7L13.1 12.173C12.7685 12.4215 12.3745 12.5728 11.9619 12.6101C11.5494 12.6473 11.1346 12.5691 10.764 12.384V12.384C10.4479 12.2259 10.1739 11.995 9.96452 11.7103C9.75519 11.4255 9.61653 11.0951 9.55998 10.7462C9.50343 10.3974 9.53061 10.0401 9.63928 9.70376C9.74794 9.36747 9.93498 9.06181 10.185 8.812L15.95 3.05C16.6 2.40001 17.3718 1.88442 18.2211 1.53268C19.0704 1.18094 19.9807 0.999934 20.9 1H31V13",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgHandShake = function SvgHandShake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandShake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HandShake.56749259.svg";
export { ForwardRef as ReactComponent };